module.exports = __webpack_public_path__ + "img/ps.32305128.png";